import { getJoinedWordsWithComma } from 'utils';
import { NotificationContent } from 'models/Notification';
import { getIsNativeNda } from 'agreementUtils';

export const getNudgesString = (fileNames: string[]) => {
  const length = fileNames?.length || 0;

  if (length > 3)
    return `${fileNames[0]}, ${fileNames[1]} and ${length - 2} more documents`;

  return getJoinedWordsWithComma(fileNames);
};

export const getIsNativeNdaNotification = ({
  ndaProvider,
  envelopeId,
}: NotificationContent) => getIsNativeNda({ ndaProvider }) || !envelopeId;
